import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("colecle_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default api;

export const authStore = {
    getToken: () => localStorage.getItem("colecle_token"),
    getUser: () => {
        const raw = localStorage.getItem("colecle_user");
        return raw ? JSON.parse(raw) : null;
    },
    setSession: (token, user) => {
        localStorage.setItem("colecle_token", token);
        localStorage.setItem("colecle_user", JSON.stringify(user));
    },
    clear: () => {
        localStorage.removeItem("colecle_token");
        localStorage.removeItem("colecle_user");
    },
};
